import { defineComponent, useModel, computed, openBlock, createBlock, unref, mergeModels } from "vue";
import { N as NcSelect } from "./NcSelect.mjs";
import { r as register, h as t47, a as t } from "./_l10n.mjs";
import { c as createElementId } from "./createElementId.mjs";
register(t47);
function formatTimezoneId(timezoneId) {
  return timezoneId.slice(timezoneId.indexOf("/") + 1).replaceAll("/", " - ").replaceAll("_", " ");
}
function getTimezones() {
  return Intl.supportedValuesOf("timeZone").filter((tz) => !tz.startsWith("Etc/")).map((timezoneId) => ({
    timezoneId,
    label: formatTimezoneId(timezoneId)
  })).sort((a, b) => a.timezoneId.localeCompare(b.timezoneId));
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcTimezonePicker",
  props: /* @__PURE__ */ mergeModels({
    additionalTimezones: { default: () => [] },
    uid: { default: createElementId() }
  }, {
    "modelValue": { default: "floating" },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const modelValue = useModel(__props, "modelValue");
    const props = __props;
    const formattedAdditionalTimezones = computed(() => {
      return props.additionalTimezones.map(({ timezoneId, label }) => ({
        timezoneId,
        label
      }));
    });
    const options = computed(() => {
      const timezones = getTimezones();
      timezones.unshift(...formattedAdditionalTimezones.value);
      return timezones;
    });
    function filterBy(option, label, search) {
      const terms = search.trim().split(/\s+/);
      const values = Object.values(option);
      return terms.every((term) => {
        return values.some((value) => value.toLowerCase().includes(term.toLowerCase()));
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcSelect, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
        "aria-label-combobox": unref(t)("Search for time zone"),
        clearable: false,
        filterBy,
        multiple: false,
        options: options.value,
        placeholder: unref(t)("Type to search time zone"),
        uid: __props.uid,
        reduce: (option) => option.timezoneId,
        label: "label"
      }, null, 8, ["modelValue", "aria-label-combobox", "options", "placeholder", "uid", "reduce"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcTimezonePicker.vue_vue_type_script_setup_true_lang.mjs.map
